import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-36e28468"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-flex tw-items-center" }

import AssessmentIconTooltip from "./assessmentIconTooltip.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'IconScoreAdvancedAssessment',
  props: {
    type: {},
    iconComponent: {},
    value: {},
    label: {},
    checklistItemId: {},
    isMaster: { type: Boolean },
    computedLabel: {},
    colorStyle: {},
    classIcon: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.iconComponent), {
      id: `popover-${_ctx.type}-${_ctx.checklistItemId}`,
      class: _normalizeClass([
        'info-icon',
        _ctx.type,
        _ctx.value ? _ctx.colorStyle[_ctx.value] : 'tw-text-[#DBDBDB]',
        _ctx.isMaster ? 'tw-text-[#666666]' : '',
        _ctx.classIcon,
      ])
    }, null, 8, ["id", "class"])),
    _createVNode(AssessmentIconTooltip, {
      id: `popover-${_ctx.type}-${_ctx.checklistItemId}`,
      text: `${_ctx.label} - ${_ctx.computedLabel}`,
      class: "!tw-top-[-22px]"
    }, null, 8, ["id", "text"])
  ]))
}
}

})